import React from 'react'

import TransactionConfirmationModal, {
  ConfirmationModalContent,
} from '../../../components/TransactionConfirmationModal'
import DoubleCurrencyLogo from '../../../components/DoubleLogo'
import type { AddLiquidityControllerResult } from '../../../features/liquidity/useAddLiquidityController'
import { MintField as Field } from '../../../domain/liquidity'
import { ConfirmAddModalBottom } from './ConfirmAddModalBottom'

export function AddLiquidityConfirmModal({ controller }: { controller: AddLiquidityControllerResult }) {
  const {
    allowedSlippage,
    attemptingTxn,
    currencies,
    handleDismissConfirmation,
    liquidityMinted,
    noLiquidity,
    onAdd,
    parsedAmounts,
    pendingText,
    poolTokenPercentage,
    price,
    showConfirm,
    txHash,
    walletErrorMessage,
  } = controller

  const modalHeader = () =>
    noLiquidity ? (
      <div className="mt-4 flex flex-col gap-4">
        <div className="glass-elevated flex items-center gap-3 rounded-xl p-4">
          <span className="text-4xl font-semibold tabular-nums">
            {currencies[Field.CURRENCY_A]?.symbol}/{currencies[Field.CURRENCY_B]?.symbol}
          </span>
          <DoubleCurrencyLogo
            currency0={currencies[Field.CURRENCY_A]}
            currency1={currencies[Field.CURRENCY_B]}
            size={30}
          />
        </div>
      </div>
    ) : (
      <div className="mt-4 flex flex-col gap-4">
        <div className="mt-5 flex items-center gap-3">
          <span className="text-4xl font-semibold tabular-nums">{liquidityMinted?.toSignificant(6)}</span>
          <DoubleCurrencyLogo
            currency0={currencies[Field.CURRENCY_A]}
            currency1={currencies[Field.CURRENCY_B]}
            size={30}
          />
        </div>
        <div>
          <span className="text-2xl">
            {currencies[Field.CURRENCY_A]?.symbol}/{currencies[Field.CURRENCY_B]?.symbol} Pool Tokens
          </span>
        </div>
        <p className="text-xs italic text-muted-foreground">
          {`Output is estimated. If the price changes by more than ${
            allowedSlippage / 100
          }% your transaction will revert.`}
        </p>
      </div>
    )

  const modalBottom = () => (
    <>
      {walletErrorMessage ? (
        <p className="mb-3 text-sm text-destructive" role="alert">
          {walletErrorMessage}
        </p>
      ) : null}
      <ConfirmAddModalBottom
      price={price}
      currencies={currencies}
      parsedAmounts={parsedAmounts}
      noLiquidity={noLiquidity}
      onAdd={onAdd}
      poolTokenPercentage={poolTokenPercentage}
    />
    </>
  )

  return (
    <TransactionConfirmationModal
      isOpen={showConfirm}
      onDismiss={handleDismissConfirmation}
      attemptingTxn={attemptingTxn}
      hash={txHash}
      content={() => (
        <ConfirmationModalContent
          title={noLiquidity ? 'You are creating a pool' : 'You will receive'}
          onDismiss={handleDismissConfirmation}
          topContent={modalHeader}
          bottomContent={modalBottom}
        />
      )}
      pendingText={pendingText}
    />
  )
}
